var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative min-h-106px",class:{ 'loading-fill': _vm.fill }},[(_vm.loading)?_c('div',{staticClass:"absolute left-1/2 top-4 transform -translate-x-1/2 z-10"},[_c('LoadingSpinner')],1):_vm._e(),_c('div',{staticClass:"transition-opacity duration-500",class:{
      'opacity-25 pointer-events-none': _vm.loading,
      'loading-fill': _vm.fill,
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }